import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Empty from '../../Layouts/Empty';
import LoadingButton from '../../UI/LoadingButton';
import zxcvbn from 'zxcvbn';
import { withTranslation } from 'react-i18next';
import {
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  FormFeedback,
} from 'reactstrap';
import { UncontrolledAlert } from 'reactstrap';
import { Formik } from 'formik';
import { validationSchema } from './validation';

export class Register extends Component {
  constructor(props) {
    super(props);
    const { invitationInfo } = this.props;
    this.state = {
      firstName: invitationInfo.firstName,
      lastName: invitationInfo.lastName,
      displayName: invitationInfo.firstName + ' ' + invitationInfo.lastName,
      email: invitationInfo.email,
      password: '',
      confirmPassword: '',
      error: '',
    };
  }

  getPasswordStrength = (password) => {
    return zxcvbn(password).score;
  };

  onRegister = (values) => {
    const {
      firstName,
      lastName,
      displayName,
      email,
      password,
      confirmPassword,
    } = values;
    this.props.onRegister(firstName, lastName, displayName, email, password);
  };

  render() {
    const { error, t, loading } = this.props;
    return (
      <Empty>
        <h1 className="text-center">
          <img
            src={process.env.PUBLIC_URL + window.configs.LOGIN_LOGO}
            width="300"
            alt="Logo"
          />
        </h1>
        <h3>New User Registration</h3>
        <Formik
          initialValues={this.state}
          validationSchema={validationSchema}
          onSubmit={(values) => this.onRegister(values)}
        >
          {({
            values,
            handleChange,
            errors,
            setFieldTouched,
            touched,
            isValid,
            handleSubmit,
          }) => {
            return (
              <Form>
                <FormGroup>
                  <Label for="firstName">{t('First Name')}</Label>
                  <Input
                    id="firstName"
                    onChange={handleChange('firstName')}
                    invalid={
                      touched.firstName && errors.firstName ? true : false
                    }
                    value={values.firstName}
                  />
                  {touched.firstName && errors.firstName && (
                    <FormFeedback>{t(errors.firstName)}</FormFeedback>
                  )}
                </FormGroup>

                <FormGroup>
                  <Label for="lastName">{t('Last Name')}</Label>
                  <Input
                    id="lastName"
                    onChange={handleChange('lastName')}
                    invalid={touched.lastName && errors.lastName ? true : false}
                    value={values.lastName}
                  />
                  {touched.lastName && errors.lastName && (
                    <FormFeedback>{t(errors.lastName)}</FormFeedback>
                  )}
                </FormGroup>

                <FormGroup>
                  <Label for="displayName">{t('Display Name')}</Label>
                  <Input
                    id="displayName"
                    onChange={handleChange('displayName')}
                    invalid={
                      touched.displayName && errors.displayName ? true : false
                    }
                    value={values.displayName}
                  />
                  {touched.displayName && errors.displayName && (
                    <FormFeedback>{t(errors.displayName)}</FormFeedback>
                  )}
                </FormGroup>

                <FormGroup>
                  <Label htmlFor="email">{t('Email')}</Label>
                  <Input
                    type="email"
                    id="email"
                    disabled
                    value={values.email}
                  />
                </FormGroup>

                <FormGroup>
                  <FormText>
                    {t(
                      'Password must have more than 10 characters, and contain at least one uppercase and one special character',
                    )}
                  </FormText>
                </FormGroup>

                <FormGroup>
                  <Label for="password">{t('Password')}</Label>
                  <Input
                    id="password"
                    onChange={handleChange('password')}
                    type="password"
                    invalid={touched.password && errors.password ? true : false}
                  />
                  <meter
                    max="4"
                    value={this.getPasswordStrength(values.password)}
                  />
                  {touched.password && errors.password && (
                    <FormFeedback>{errors.password}</FormFeedback>
                  )}
                </FormGroup>

                <FormGroup>
                  <Label htmlFor="confirmPassword">
                    {t('Confirm password')}
                  </Label>
                  <Input
                    type="password"
                    id="confirmPassword"
                    onChange={handleChange('confirmPassword')}
                    invalid={
                      touched.confirmPassword && errors.confirmPassword
                        ? true
                        : false
                    }
                  />
                  {touched.confirmPassword && errors.confirmPassword && (
                    <FormFeedback>{errors.confirmPassword}</FormFeedback>
                  )}
                </FormGroup>

                {error ? (
                  <UncontrolledAlert color="danger" fade={false}>
                    <i
                      className="md-icon"
                      style={{ verticalAlign: 'text-bottom', marginRight: 10 }}
                    >
                      error
                    </i>
                    <span>{error}</span>
                  </UncontrolledAlert>
                ) : null}

                <div className="form-group form-group-button">
                  <div
                    className="form-group-button-description"
                    style={{ float: 'left' }}
                  >
                    <Link to={window.configs.REGISTER_HELP_LINK || '#'}>
                      {t("Can't register? Contact us")}
                    </Link>
                  </div>
                  <LoadingButton
                    classes="button button-primary button-right"
                    loading={loading ? true : undefined}
                    onClick={(e) => {
                      e.preventDefault();
                      handleSubmit();
                    }}
                  >
                    {t('Register')}
                  </LoadingButton>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Empty>
    );
  }
}

export default withTranslation('app')(Register);
